import gql from "graphql-tag";

const GET_NOTIFICATIONS_COUNT = gql`
  query getNotificationsCount($filter: getNotificationsFilter) {
    getNotificationsCount(filter: $filter)
  }
`;
export default GET_NOTIFICATIONS_COUNT;
